import { useAppSelector } from '../redux/hooks'
import { getPresenceStatus, type PresenceView } from '../utils/presence'

/**
 * One user's status (see utils/presence.ts). Selects only that user's entry
 * and the minute tick, so another user's flip doesn't re-render the caller;
 * selecting the whole `userStatus` slice re-rendered every chat list on every
 * flip. Null for no id (groups, announcements) or no status yet.
 */
export const usePresenceStatus = (userId: number | string | null | undefined): PresenceView | null => {
  const entry = useAppSelector((state) => (userId ? state.userStatus.userStatuses[userId] : undefined))
  const presenceNow = useAppSelector((state) => state.userStatus.presenceNow)
  return getPresenceStatus(entry, presenceNow)
}
